module.exports = __webpack_public_path__ + "static/media/avg_session_length_per_user.2844d415.svg";